'use client';

import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { QueryApi } from '@/features/query/api';
import { useSelectedCurrency } from '@/shared/lib/hooks/useSelectedCurrency';
import { Currency } from '@/shared/model/Currency';
import { Dropdown } from '@/shared/ui/dropdown';
import { Icon } from '@/shared/ui/icon';
import './currency-select.scss';

type Props = {
    variant?: 'default' | 'compact';
};
export const CurrencySelect = ({ variant = 'default' }: Props) => {
    const t = useTranslations();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useSelectedCurrency();
    const { data: venue } = useQuery(QueryApi.Venue.queries.Venue);

    if (!selectedCurrency || (venue?.currencies?.length ?? 0) <= 1) {
        return null;
    }

    return (
        <Dropdown open={isOpen} onOpenChange={setIsOpen}>
            <Dropdown.Trigger className="currency-select__trigger" data-state={isOpen ? 'open' : 'closed'}>
                {variant === 'compact' ? (
                    <>
                        <div className="currency-select__trigger-label">
                            <Icon name="coins" width={24} height={24} />
                            <span>{selectedCurrency}</span>
                        </div>
                    </>
                ) : (
                    <div className="currency-select__content">
                        <span className="currency-select__label">{t('CURRENCY_SELECT.LABEL')}</span>
                        <span className="currency-select__value">{selectedCurrency}</span>
                    </div>
                )}
            </Dropdown.Trigger>
            <Dropdown.Content className="z-[1001]!">
                {(venue?.currencies as Currency[])?.map((currency) => {
                    return (
                        <Dropdown.Item
                            key={currency}
                            onSelect={() => setSelectedCurrency(currency)}
                            data-testid="currency-select-item"
                            data-value={currency}
                        >
                            {currency}
                        </Dropdown.Item>
                    );
                })}
            </Dropdown.Content>
        </Dropdown>
    );
};
